import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

var _templateObject, _templateObject2, _templateObject3;

/* eslint-disable styled-components-a11y/no-static-element-interactions */

/* eslint-disable styled-components-a11y/click-events-have-key-events */
import { transparentize } from 'polished';
import { useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { useTranslation } from '@yoweb/next-i18next';
import { FaqHero } from '@yoweb/prismic-slicemachine/components/faq/FaqHero';
import { FaqGroupView } from '@yoweb/prismic-slicemachine/components/faq/FaqGroupView';
import { getCachedPrismicDomainMapping } from '@yoweb/prismic-slicemachine/constants/config';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import HeroImage from '@poplar/public/images/FAQ.svg';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { CloseIcon, ContactUsIcon } from '@yoweb/ui/components/Icon';
import { getZIndexValue } from '@yoweb/ui/styles/utils/mixins.utils';
import { FaqCTAForm } from '@yoweb/ui/components/help/FaqCTAForm';
import { getSpace, getZIndex, th } from '@yoweb/ui/styles/utils/theme';
import { theme } from '@yoweb/ui/styles';
import { ButtonIcon, ButtonIconWithHoverLabel } from '@yoweb/ui/components/buttons';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var HelpPage = function HelpPage(_ref) {
  var prismicData = _ref.prismicData;

  var _useTranslation = useTranslation(['common', 'faq', 'help-form']),
      t = _useTranslation.t;

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var config = useExternalConfig();

  var _useState = useState(false),
      isCTAModalOpen = _useState[0],
      setCTAIsModalOpen = _useState[1];

  var _useToast = useToast(),
      showToastMessage = _useToast.showToastMessage;

  var modalActions = {
    open: function open() {
      return setCTAIsModalOpen(true);
    },
    close: function close() {
      return setCTAIsModalOpen(false);
    }
  };
  var reversedDomains = getCachedPrismicDomainMapping(config.env, {
    StoreUS: config.baseStoreUsURL,
    StoreJP: config.baseStoreJpURL,
    PoplarUS: config.baseUsUrl,
    PoplarJP: config.baseJpUrl
  });

  var onSubmitted = function onSubmitted() {
    setCTAIsModalOpen(false);
    showToastMessage({
      message: t('faq:form.success.message')
    });
  };

  return /*#__PURE__*/_jsxs(PageWrapper, {
    children: [/*#__PURE__*/_jsx(FaqHero, {
      label: t('faq:hero.label'),
      title: t('faq:hero.title'),
      subtitle: t('faq:hero.subtitle'),
      image: HeroImage
    }), /*#__PURE__*/_jsx(FaqGroupView, {
      query: query,
      prismicData: prismicData,
      reversedDomains: reversedDomains,
      internalURLs: []
    }), /*#__PURE__*/_jsxs(FixedContainer, {
      children: [!isCTAModalOpen && /*#__PURE__*/_jsx(ButtonIconWithHoverLabel, {
        onClick: modalActions.open,
        variant: "primary",
        size: "md",
        icon: /*#__PURE__*/_jsx(ContactUsIcon, {
          size: pxToRem(26)
        }),
        hasShadow: true,
        hoverLabel: t('faq:form.contact-us'),
        "data-testid": "faq-support-btn"
      }), /*#__PURE__*/_jsx(Overlay, {
        isOpen: isCTAModalOpen,
        onClick: modalActions.close
      }), /*#__PURE__*/_jsxs(CTAModalContainer, {
        isOpen: isCTAModalOpen,
        children: [/*#__PURE__*/_jsx(CloseButton, {
          "aria-label": t('close'),
          "data-testid": "faq-modal-close-btn",
          onClick: modalActions.close,
          variant: "tertiary",
          icon: /*#__PURE__*/_jsx(CloseIcon, {}),
          size: "lg",
          isFloating: false,
          radius: "full"
        }), /*#__PURE__*/_jsx(FaqCTAForm, {
          onSubmitted: onSubmitted
        })]
      })]
    })]
  });
};

var PageWrapper = styled.div.withConfig({
  componentId: "sc-10p1423-0"
})(["padding-top:", ";", ""], th.getSpace('medium1'), media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-top: 0;\n  "]))));
var FixedContainer = styled.div.withConfig({
  componentId: "sc-10p1423-1"
})(["position:fixed;display:block;bottom:", ";right:", ";border:none;z-index:", ";"], pxToRem(47), pxToRem(30), getZIndexValue('popover'));
var CTAModalContainer = styled.div.withConfig({
  componentId: "sc-10p1423-2"
})(["position:fixed;background-color:", ";top:0;bottom:0;left:0;display:block;width:100%;padding:0;overflow-y:auto;z-index:", ";opacity:", ";transform:", ";transition:opacity 0.3s ease,transform 0.3s ease;", ""], th.getColor('base000'), getZIndexValue('popover'), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 1 : 0;
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? 'translateY(0)' : 'translateY(100%)';
}, media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      background-color: inherit;\n      inset: inherit;\n      position: absolute;\n      width: ", ";\n      bottom: ", ";\n      right: ", ";\n      padding: 0 ", " 0 ", ";\n      min-width: ", ";\n      max-width: calc(100vw - ", ");\n      max-height: calc(100vh - ", ");\n  "])), pxToRem(450), pxToRem(10), pxToRem(10), pxToRem(0), pxToRem(32), pxToRem(350), pxToRem(10), pxToRem(30)));
var Overlay = styled.div.withConfig({
  componentId: "sc-10p1423-3"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background:", ";z-index:", ";display:", ";"], transparentize(0.4, theme.colors.base400), getZIndex('above'), function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? 'block' : 'none';
});
var CloseButton = styled(ButtonIcon).withConfig({
  componentId: "sc-10p1423-4"
})(["&&{position:absolute;right:", ";top:", ";z-index:", ";", "}"], getSpace('small1'), getSpace('small1'), getZIndex('modal'), media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      right: ", ";\n      top: ", ";\n    "])), getSpace('small1'), getSpace('small1')));
HelpPage.layout = {
  type: 'poplar',
  props: {
    noSmallPadding: true
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(HelpPage);